import { styled } from '@mui/material';

import { useModalMenuContext } from '@app-velocity/ui';

import { UserProfile } from '../UserProfile';
import { Notifications } from '../Notifications';
import { OrgUsage } from '../OrgUsage';

const StyledModalContent = styled('div')({
  width: '100%',
  minWidth: 520,
});

export const UserSettingsSections = () => {
  const { selectedMenuKey } = useModalMenuContext();

  return (
    <StyledModalContent>
      {selectedMenuKey === 'profile' ? <UserProfile /> : null}
      {selectedMenuKey === 'notifications' ? <Notifications /> : null}
      {selectedMenuKey === 'org-usage' ? <OrgUsage /> : null}
    </StyledModalContent>
  );
};
